<template>
  <div>
    <v-menu offset-y
            v-model="showMenu"
            z-index="300"
            :disabled="disabled"
            :close-on-content-click="!multiple">
      <template v-slot:activator="{ on, attrs }">
        <div>
          <!-- 单选 -->
          <div v-if="!multiple"
               style="width:100%">
            <div :style="{
                'font-size': '13px',
                color:
                  errMsg && errMsg.length > 0
                    ? '#ff5252'
                    : 'rgba(0, 0, 0, 0.78)',
              }"
                 class="pl-2">
              {{ label }}
              <slot name="label"></slot>
            </div>
            <div class="d-flex justify-space-between align-center pl-2"
                 v-bind="attrs"
                 ref="inputDv"
                 v-on="on"
                 :style="{
                width: '100%',
                'background-color': disabled ? backgroundColor : '#F5F5F5',
                'border-bottom': !color
                  ? '1px solid rgba(0, 0, 0, 0.38)'
                  : '2px solid #0f46c1',
                'border-radius': ' 4px 4px 0px 0px',
              }">
              <div class="d-flex align-center">
                <div class="mr-2">
                  <v-img :src="viewList.src"
                         width="32"
                         class="grey lighten-2"
                         style="border-radius: 50%"
                         height="32"></v-img>
                </div>
                <div style="font-size: 16px;color: rgba(0, 0, 0, 0.87)"
                     class="d-flex">
                  <span style="font-size: 16px;color: rgba(0, 0, 0, 0.87);">{{
                    INT(viewList[itemText])
                  }}</span>
                  <span class="mr-2 ml-2"
                        v-if="viewList[itemText] && viewList[staffCode]">/</span>
                  <span>{{ INT(viewList[staffCode]) }}</span>
                </div>
              </div>
              <input type="text"
                     @focus="focusSearch"
                     @blur="cleanSearch"
                     @input="input"
                     :placeholder="
                  viewList[itemText] || viewList[staffCode]
                    ? ''
                    : placeholder
                    ? placeholder
                    : $t('label_Employee_name')
                "
                     v-model="search"
                     :disabled="disabled"
                     style="border:none;outline:none;height:44px;flex:1;" />
              <div style="line-height:44px"
                   v-if="!disabled">
                <v-icon class="material-icons"
                        style="font-size:28px;">{{ !showMenu ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </v-icon>
              </div>
            </div>
          </div>
          <!-- 多选 -->
          <div v-else
               style="width:100%">
            <div :style="{
                'font-size': '13px',
                color:
                  errMsg && errMsg.length > 0
                    ? '#ff5252'
                    : 'rgba(0, 0, 0, 0.78)',
              }"
                 class="pl-2">
              {{ label }}
              <slot name="label"></slot>
            </div>
            <div class="d-flex pl-2"
                 v-bind="attrs"
                 ref="inputDv"
                 v-on="on"
                 :style="{
                width: '100%',
                'background-color': disabled ? backgroundColor : '#F5F5F5',
                'border-bottom': !color
                  ? '1px solid rgba(0, 0, 0, 0.38)'
                  : '2px solid #0f46c1',
                'border-radius': ' 4px 4px 0px 0px',
              }">
              <div class="d-flex align-center">
                <v-chip class="mr-3"
                        @click:close="closeChip(item)"
                        v-for="item in viewList"
                        :key="item[itemKey]"
                        :close="!disabled">
                  {{ INT(item.staff_email) }}
                  <!-- <v-img src=""
                         width="24"
                         style="border-radius: 50%"
                         height="24"></v-img>
                  <span class="ml-2 "
                        style="font-size: 16px;color: rgba(0, 0, 0, 0.87)">
                    <span>{{item[itemText]}}</span>
                    <span class="mr-1 ml-1">/</span>
                    <span>{{item[staffCode]}}</span>
                  </span> -->
                </v-chip>
                <v-chip v-for="(item, index) in propertylist"
                        class="mr-1"
                        :key="index"
                        :close="!disabled"
                        @click:close="closeChipProperty(item, index)">
                  {{ INT(item.property) }}
                </v-chip>
              </div>
              <div class="d-flex justify-space-between align-center"
                   style="width:100%">
                <input type="text"
                       @focus="focusSearch"
                       @blur="cleanSearch"
                       :placeholder="
                    viewList.length > 0
                      ? ''
                      : placeholder
                      ? placeholder
                      : $t('label_Employee_name')
                  "
                       :disabled="disabled"
                       @input="input"
                       v-model="search"
                       style="border:none;outline:none;height:44px;width:100%;" />
                <div style="line-height:44px"
                     v-if="!disabled">
                  <v-icon class="material-icons"
                          style="font-size:28px;">{{ !showMenu ? 'arrow_drop_down' : 'arrow_drop_up' }}
                  </v-icon>
                </div>
              </div>
            </div>
          </div>
          <div v-if="errMsg && errMsg.length > 0"
               style="color: #ff5252;font-size:12px;">
            {{ errMsg[0] }}
          </div>
        </div>
      </template>
      <!-- ----------------------------下拉列表 -------------------------------------->
      <v-list style="max-height:361px">
        <v-list-item v-for="(item, index) in selectList"
                     :style="{
            background: item.checked && multiple ? '#E5EEFF' : '#ffffff',
          }"
                     :key="index"
                     @click="selectItem(item)"
                     class="pl-0">
          <v-list-item-title>
            <!-- 单选 -->
            <div v-if="!multiple"
                 style="height:64px;width:100%"
                 class="d-flex align-center">
              <div class="mr-4 ml-4">
                <v-img src=""
                       width="48"
                       style="border-radius: 50%"
                       height="48"></v-img>
              </div>
              <div style="width:100%">
                <div class="d-flex justify-space-between align-center mb-1">
                  <span style="font-size: 16px;color: rgba(0, 0, 0, 0.87)">
                    {{ INT(item[itemText]) }}
                    <span class="mr-2 ml-2"
                          v-if="item[itemText] && item[staffCode]">/</span>
                    {{ INT(item[staffCode]) }}
                  </span>
                  <span style="font-size: 14px;color: rgba(0, 0, 0, 0.38);position: relative;top: 9px;">{{ INT(item.user_id) }}</span>
                </div>
                <div>
                  <span style="font-size: 12px;color: rgba(0, 0, 0, 0.38)">{{
                    INT(item.post_and_grade)
                  }}</span>
                  <span class="mr-2 ml-2">-</span>
                  <span style="font-size: 12px;color: rgba(0, 0, 0, 0.38)">{{
                    INT(item.client_and_org) | replaceclient_and_org
                  }}</span>
                </div>
              </div>
            </div>
            <!-- 多选 -->
            <div v-if="multiple"
                 :style="{ height: '72px', width: '100%' }"
                 class="d-flex align-center">
              <div>
                <v-checkbox class="mx-2"
                            v-model="item.checked"
                            @change="changeChecked(item)"></v-checkbox>
              </div>
              <div class="mr-4">
                <v-img src=""
                       width="48"
                       style="border-radius: 50%"
                       height="48"></v-img>
              </div>
              <div style="width:100%">
                <div class="d-flex justify-space-between align-center mb-1">
                  <span style="font-size: 16px;color: rgba(0, 0, 0, 0.87)">
                    {{ INT(item[itemText]) }}
                    <span class="mr-2 ml-2"
                          v-if="item[itemText] && item[staffCode]">/</span>
                    {{ INT(item[staffCode]) }}
                  </span>
                  <span style="font-size: 14px;color: rgba(0, 0, 0, 0.6)">{{
                    INT(item.user_id)
                  }}</span>
                </div>
                <div>
                  <span style="font-size: 14px;color: rgba(0, 0, 0, 0.6)">{{
                    INT(item.post_and_grade)
                  }}</span>
                  <span class="mr-2 ml-2">-</span>
                  <span style="font-size: 14px;color: rgba(0, 0, 0, 0.6)">{{
                    INT(item.client_and_org) | replaceclient_and_org
                  }}</span>
                </div>
              </div>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
/**
 * 单选多选人员组件 AutoComplete
 *
 */
import { getStaffListForFilter } from '@/service/api/autoComplete.js'
export default {
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Staff',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      //多选or单选 默认单选
      type: Boolean,
      default: false,
    },
    staffUuid: {
      //员工uuid
      type: String,
    },
    filter: {
      //过滤条件 默认为空
      type: String,
    },
    dropDownList: {
      //请求函数
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
    },
    errMsg: {
      //验证
    },
    propertylist: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: 'uuid',
    },
    itemText: {
      type: String,
      default: 'show_name',
    },
    staffCode: {
      type: String,
      default: 'staff_code',
    },
    job_post_name: {
      type: String,
      default: 'job_post_name',
    },
    job_grade_name: {
      type: String,
      default: 'job_grade_name',
    },
    client_name: {
      //客户名称
      type: String,
      default: 'client_name',
    },
    org_level_name: {
      //单位名称
      type: String,
      default: 'org_level_all',
    },
    dept_name: {
      type: String,
      default: 'dept_name',
    },
    staff_avatar: {
      //图片地址
      type: [String, Object],
    },
  },
  model: {
    prop: 'staffUuid',
    event: 'changeStaff',
  },
  data () {
    return {
      color: false,
      showMenu: false,
      allList: [], //所有员工列表
      selectList: [], //过滤后的员工列表
      viewList: {}, //用户选中的员工  数组or对象
      search: '', //搜索字段
    }
  },
  computed: {},
  filters: {
    replaceclient_and_org (val) {
      if (!val) return ''
      // return val.replaceAll('\\', '>').replaceAll('/', '>')
      return String(val).replace(/\//g, '>')
    },
  },
  async created () { },
  watch: {
    staffUuid (v) {
      this.getStaffInfo()
    },
    errMsg: {
      handler (val) {
        if (val.length > 0)
          this.$refs.inputDv.style.borderBottom = '1px solid #ff5252'
        else this.$refs.inputDv.style.borderBottom = '2px solid #0f46c1'
      },
      deep: true,
    },
  },
  async mounted () {
    // console.log(this.itemKey);
    await this.getSelectList()
    this.selectList = this.allList
    this.getStaffInfo()
  },
  methods: {
    focusSearch () {
      if (Array.isArray(this.errMsg) && this.errMsg.length > 0)
        this.$refs.inputDv.style.borderBottom = '1px solid #ff5252'
      else {
        this.color = true
      }
      // console.log('获取', this.color);
    },
    cleanSearch () {
      this.color = false
      this.search = ''
    },
    selectItem (val) {
      if (!this.multiple) {
        this.$emit('changeStaff', val[this.itemKey])
        this.$emit('changeStaffList', val)
        this.search = ''
      }
    },
    closeChip (val) {
      this.changeViewList(val)
    },
    closeChipProperty (val, index) {
      this.$emit('closeChipProperty', val, index)
    },
    changeViewList (val) {
      this.viewList = this.viewList.filter((item) => {
        return item[this.itemKey] != val[this.itemKey]
      })
      this.$emit('changeStaffList', this.viewList)
      let res = this.viewList.map((item) => {
        return item[this.itemKey]
      })
      this.$emit('changeStaff', res.join())
    },
    changeChecked (val) {
      if (val.checked) {
        this.viewList.push(val)
        this.$emit('changeStaffList', this.viewList)
        let res = this.viewList
        res = res.map((item) => {
          return item[this.itemKey]
        })
        this.$emit('changeStaff', res.join())
      } else {
        if (this.viewList.length > 0) {
          this.changeViewList(val)
        } else {
          this.viewList = []
          this.$emit('changeStaffList', this.viewList)
          this.$emit('changeStaff', '')
        }
      }
    },
    input () {
      //搜索
      if (this.search != '') {
        let arr = []
        this.allList.map((item) => {
          let isNo = false
          let isNo2 = false
          if (item[this.itemText].includes(this.search)) {
            isNo = true
            isNo2 = true
            arr.push(item)
          }
          if (item[this.staffCode].includes(this.search)) {
            if (!isNo) {
              isNo2 = true
              arr.push(item)
            }
          }
          if (item.staff_email.includes(this.search)) {
            if (!isNo2) {
              arr.push(item)
            }
          }
        })
        this.selectList = this.$clone(arr)
      } else {
        this.selectList = this.allList
      }
      this.showMenu = true
    },
    async getSelectList () {
      //根据filter获取过滤条件 获取所有员工
      if (!this.dropDownList.length > 0) {
        const res = await getStaffListForFilter({
          filter: this.filter,
          org_level_uuid: this.$store.state.currentCompany,
        })
        if (res.code == 200) {
          if (!this.allList.length > 0) {
            this.allList = res.data.map((item) => {
              item.checked = false
              return item
            })
          }
        }
      } else {
        this.allList = this.dropDownList.map((item) => {
          item.checked = false
          return item
        })
      }
    },
    getStaffInfo () {
      if (!this.allList.length > 0) this.getSelectList()
      if (this.multiple) {
        //多选
        if (this.staffUuid == '' || !this.staffUuid) {
          this.selectList = this.selectList.map((item) => {
            item.checked = false
            return item
          })
          return (this.viewList = [])
        }
        const res = this.staffUuid.split(',')
        this.viewList = []
        this.allList.map((item) => {
          item.checked = false
          res.map((item1) => {
            if (item1 == item[this.itemKey]) {
              item.checked = true
              this.viewList.push(item)
            }
          })
        })
        this.$emit('changeStaffList', this.viewList)
      } else {
        //单选
        if (this.staffUuid == '' || !this.staffUuid) return (this.viewList = {})
        this.viewList = {}
        this.allList.map((item) => {
          if (this.staffUuid == item[this.itemKey]) {
            this.viewList = item
          }
        })
        this.$emit('changeStaffList', this.viewList)
      }
    },
  },
}
</script>

<style scoped></style>
